export const baseURL = process.env.NODE_ENVIRONMENT === 'production' ?
"https://investiv-server.herokuapp.com/" : "http://localhost:2000/";

export const truncate = string =>
  string.length > 200 ? string.substring(0, 200) + "..." : string;

// Example POST method implementation:
export async function postData(page, data = {}) {
  // Default options are marked with *
  const newUrl = baseURL + page;
  const response = await fetch(newUrl, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });

  return response.json(); // parses JSON response into native JavaScript objects
}



// WEBPACK FOOTER //
// /opt/build/repo/src/helpers/utils.js